import Component from '@ember/component';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import type UploadContactsService from 'donor-elf-web/services/upload-contacts';
import type { ColumnMapping } from 'donor-elf-web/services/upload-contacts';

/*
  attrs
    - mappingIndex
*/

interface ComponentArgs {
  mappingIndex: number;
}

export default class ContactUploadMappingComponent extends Component<ComponentArgs> {
  @service declare uploadContacts: UploadContactsService;

  @tracked mappingIndex: number = -1;

  get mapping() {
    return this.uploadContacts.columnMappings[this.mappingIndex];
  }

  get propertyOptions() {
    let mappedProperties: Record<string, boolean> = {};
    let thisProperty = get(this, 'mapping.property');

    this.uploadContacts.columnMappings.forEach((mapping: ColumnMapping) => {
      let prop = get(mapping, 'property');
      if (!isEmpty(prop) && prop !== thisProperty) {
        mappedProperties[mapping.property] = true;
      }
    });

    return this.uploadContacts.propertyOptions.filter((item) => {
      return !mappedProperties[get(item, 'val')];
    });
  }

  onSelectChange = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    const val = target.value;

    if (this.mapping) {
      this.mapping.property = val;
    }
  };
}
